// Roles: the admin can do everything; "manager" is the Station Manager.
export const ROLE_LABELS = { admin: "Admin", manager: "Station Manager", accountant: "Accountant" };
export const roleLabel = (role) => ROLE_LABELS[role] || role;
// Can act as the accountant (accounting, reconciliations, approvals, settings that are controls)
export const isAccountant = (user) => user?.role === "accountant" || user?.role === "admin";
// Can act as the Station Manager (manager-only steps such as manager review, deleting a draft)
export const isManager = (user) => user?.role === "manager" || user?.role === "admin";
export const isAdmin = (user) => user?.role === "admin";
